<template>
  <div class="meta-time-box" v-if="createdAt || updatedAt">
    <span class="create-time" v-if="createdAt">Создано: {{ formatDateAndTime(createdAt) }}</span>
    <span class="update-time" v-if="updatedAt">Обновлено: {{ formatDateAndTime(updatedAt) }}</span>
  </div>
</template>

<script>
import { formatDateAndTime, formatDateAndTimeLocal } from "@/utils/dateUtils";

export default {
  name: "MetaTime",
  props: {
    localTime: { type: Boolean, default: false },
    createdAt: { type: String, required: false },
    updatedAt: { type: String, required: false },
  },
  data() {
    return {};
  },
  methods: {
    formatDateAndTime(value) {
      return this.localTime ? formatDateAndTimeLocal(value) : formatDateAndTime(value);
    },
  },
};
</script>

<style scoped>
.meta-time-box {
  display: flex;
  flex-direction: column;
}

.create-time,
.update-time {
  color: #666;
  font-style: italic;
  font-size: 14px;
}

.update-time {
  margin-top: 5px;
}
</style>
